import React from 'react';
import { Link , useLocation } from 'react-router-dom';

const Header = ({header}) => {

  console.log(location.pathname)
  const pathSegments =  location.pathname.split('/').filter(Boolean)

  return (
       <div style={{textAlign: 'center'}}>
           <h5 className="text-capitalize">{header}</h5>
        </div>
  );
};

export default Header;